module.exports = __webpack_public_path__ + "static/media/5.b8d470bd.svg";